import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment'
import { HttpClient } from '@angular/common/http';
import { ClosePeriodType, CacheService } from '@mapfre-tech/amap3';
import { map } from 'rxjs/operators';

import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
@Injectable({
  providedIn: 'root'
})
export class TypeClosePeriodService {

  className = 'TypeClosePeriodService';

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  getAllTypeClosePeriods(cache = true, cacheKey = "allClosePeriod"): Observable<ClosePeriodType[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      const observable = this.http.get<ClosePeriodType[]>(environment.base_URL + "/types-close-periods").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }
    
  newTypeClosePeriod(newTipoCierrePeriodo: ClosePeriodType) {
    return this.http.post(environment.base_URL + "/types-close-periods", newTipoCierrePeriodo);
  }

}
